import { createSlice } from '@reduxjs/toolkit';
import type { RoomInfoStateType } from './types';
import { actualizePackageSuccess } from '../../actions/actualization';

export const initialState: RoomInfoStateType = {
  id: null,
  hotel_id: null,
  room_type_id: null,
  facilities: [],
  area: null,
  description: null,
  name_ru: null,
  name_en: null,
  images: [],
};

export const roomInfoSlice = createSlice({
  name: 'roomInfo',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(actualizePackageSuccess, (state, action) => ({
      ...state,
      ...action.payload.data.package.room_info,
    }));
  },
});
